<template>
  <div>
    <main_pc v-if="isPc" ></main_pc>
    <main_mobile v-else></main_mobile>
  </div>
</template>
<script>
    import Main_pc from "./main_pc";
    import Main_mobile from "./main_mobile";
    export default {
      name: "index",
      components: {Main_mobile, Main_pc},
      data(){
          return {
            isPc:true,
            timer:null,
            screenWidth: document.body.clientWidth
          }
      },

      created() {
        this.isMobile();
      },

      mounted () {
        const that = this
        window.onresize = () => {
          return (() => {
            window.screenWidth = document.body.clientWidth
            that.screenWidth = window.screenWidth
          })()
        }
      },
      watch:{
        screenWidth(val){
          if(!this.timer){
            this.screenWidth = val
            this.timer = true;
            let that = this;
            setTimeout(function(){ //设置延时避免卡顿
              if(that.screenWidth < 800) {
                that.isPc = false;
              } else {
                that.isPc = true;
              }
              that.timer = false
            },400)
          }
        }
      },

      methods:{
        isMobile() {
          let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
          if(flag === null) {
            this.isPc = true;
          } else {
            this.isPc = false;
          }
        }
      }
    }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/index.vue